export type TitleSignerSource = "developer" | "technicalCustomer";

const SECTION_TWO_SIGNER_ROLE: Record<TitleSignerSource, string> = {
  developer: "Уполномоченный представитель застройщика",
  technicalCustomer: "Уполномоченный представитель технического заказчика",
};

type SignerLike = {
  signerSource?: TitleSignerSource;
  user?: {
    userId?: string;
    surname?: string;
    firstName?: string;
    middleName?: string;
  };
  surname?: string;
  firstName?: string;
  middleName?: string;
};

export const tagRepresentativesWithSource = (
  developerRepresentatives: SignerLike[] = [],
  technicalCustomerRepresentatives: SignerLike[] = [],
) => [
  ...developerRepresentatives.map((rep) => ({
    ...rep,
    signerSource: "developer" as const,
  })),
  ...technicalCustomerRepresentatives.map((rep) => ({
    ...rep,
    signerSource: "technicalCustomer" as const,
  })),
];

export const dedupeSignersByUserId = <T extends SignerLike>(signers: T[]) =>
  Object.values(
    signers.reduce<Record<string, T>>((acc, signer) => {
      const id = signer.user?.userId;
      if (id && !acc[id]) {
        acc[id] = signer;
      }
      return acc;
    }, {}),
  ) as T[];

export const formatSectionTwoSignerLabel = (signer?: SignerLike | null) => {
  if (!signer) {
    return "";
  }

  const fio = [
    signer.user?.surname ?? signer.surname,
    signer.user?.firstName ?? signer.firstName,
    signer.user?.middleName ?? signer.middleName,
  ]
    .filter(Boolean)
    .join(" ");

  const role = signer.signerSource
    ? SECTION_TWO_SIGNER_ROLE[signer.signerSource]
    : "";

  return [role, fio].filter(Boolean).join(" ");
};
